(function() {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const q = (params.get('q') || '').toLowerCase().trim();

  const redirects = [
    { match: 'in the hoop', url: '/collections/in-the-hoop-embroidery-designs' },
    { match: 'ith', url: '/collections/in-the-hoop-embroidery-designs' }
  ];

  if (path.includes('/a/search') || path.includes('/search')) {
    for (let r of redirects) {
      if (q === r.match) {
        window.location.replace(r.url);
        break;
      }
    }
  }
})();